import './ViewArea.scss';
import classNames from 'classnames';
import { isNumber } from '@sonar-software/sonar-ts-lib';
import { PeriscopeView } from '@periscopes';
import React, { useEffect } from 'react';
import { useApplicationSidebar, useOnMount, usePeriscopeCount } from '@hooks';
function getLimit(limit) {
    if (isNumber(limit)) {
        return limit;
    }
    return limit ? 2 : 0;
}
export const ViewArea = ({ children, className, direction = 'horizontal', fullHeight, fullWidth, id, collapseSidebar, noPadding, showPeriscopes, sidebar }) => {
    const periscopeCount = usePeriscopeCount();
    const { close, open, isClosed } = useApplicationSidebar();
    const periscopeLimit = getLimit(showPeriscopes);
    useOnMount(() => {
        if (collapseSidebar) {
            close();
        }
        else if (isClosed) {
            open();
        }
    });
    useEffect(() => {
        if (showPeriscopes && !collapseSidebar) {
            if (periscopeCount >= periscopeLimit) {
                close();
            }
            else {
                open();
            }
        }
    }, [close, open, periscopeCount, periscopeLimit, showPeriscopes, collapseSidebar]);
    const wrapperClasses = classNames('view-wrapper', {
        'full-height': fullHeight,
        'full-width': fullWidth || (showPeriscopes && periscopeCount),
        'no-padding': noPadding,
        'only-one-periscope': periscopeCount === 1,
        'view-horizontal': direction === 'horizontal',
        'view-vertical': direction === 'vertical'
    });
    const viewAreaClasses = classNames('view-area', { 'periscope-hidden': showPeriscopes && !periscopeCount }, className);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: wrapperClasses },
            sidebar,
            React.createElement("div", { className: viewAreaClasses, id: id }, children)),
        showPeriscopes &&
            React.createElement("div", { className: 'periscope-view-wrapper', style: { flex: periscopeCount } },
                React.createElement(PeriscopeView, { skipOnMount: true }))));
};
